import { LogModule } from '@/data/config';
import { loggerError } from '@/modules/logger';
import { isFunction } from '@/modules/validate';

/**
 * 观察者
 */
export class Observer {
  public callFunc: Function[] = [];

  // 初始化
  constructor(arrayList = []) {
    this.callFunc = arrayList;
  }

  // 增加监听器
  onListen(cb: Function) {
    if (!isFunction(cb)) {
      loggerError('传递的参数非函数', LogModule.Utils);
      return;
    }
    this.callFunc.push(cb);
  }

  onTrigger(data: any) {
    return this.callFunc.forEach((cb: Function) => cb(data));
  }

  onRemove(cb: Function) {
    return this.callFunc.filter(i => cb !== i);
  }
}
